export function OutlinedAcademySettingsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/outlined-academy-settings.svg'"></ng-include>`
    }
}